<template>
  <!-- The Modal -->
  <div class="modal fade" id="contactModal" tabindex="-1" aria-labelledby="contactModalLabel" aria-hidden="true"
    ref="contactModal">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header px-md-5 d-flex justify-content-between align-items-center">
          <h5 class="modal-title font-3 label-1" id="contactModalLabel">Contáctanos</h5>
          <button type="button" class="btn-close-custom" data-bs-dismiss="modal" aria-label="Close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        <div class="modal-body px-md-5">
          <form class="px-lg-4 px-2 d-flex flex-wrap" @submit.prevent="null">
            <div class="col-lg-6 col-12 d-flex flex-wrap pe-lg-4">
              <div class="col-12 mb-3">
                <label class="form-label text-start w-100 label-2 font-2">Nombre:</label>
                <input type="text" class="form-control font-2 inputDef py-3 ms-1" v-model="form.iName"
                  placeholder="Nombre" maxlength="50" />
              </div>
              <div class="col-12 mb-3">
                <label class="form-label text-start w-100 label-2 font-2">Teléfono:</label>
                <input type="text" class="form-control font-2 inputDef py-3 ms-1" v-model="form.iPhone"
                  placeholder="Teléfono 10 dígitos" maxlength="10" />
              </div>
              <div class="col-12 mb-3">
                <label class="form-label text-start w-100 label-2 font-2">Empresa:</label>
                <input type="text" class="form-control font-2 inputDef py-3 ms-1" v-model="form.iCompany"
                  placeholder="Empresa" maxlength="40" />
              </div>
              <div class="col-12 mb-3">
                <label class="form-label text-start w-100 label-2 font-2">Correo Electrónico:</label>
                <input type="email" class="form-control font-2 inputDef py-3 ms-1" v-model="form.iEmail"
                  placeholder="nombre@email.com" maxlength="30" />
              </div>
            </div>

            <div class="col-lg-6 col-12 d-flex flex-column align-items-start ps-lg-4">
              <div class="mb-5 col-12">
                <label class="form-label text-start w-100 label-2 font-2">Mensaje</label>
                <textarea class="form-control inputDef font-2 ms-1" v-model="form.iMessage" rows="6"
                  placeholder="Mensaje" maxlength="500"></textarea>
              </div>
              <div class="mb-3 col-12 d-flex align-items-center justify-content-end">
                <button class="btn-contact fuente-nova2" @click="validateForm">Enviar</button>
              </div>
              <div class="mb-3 col-12 d-flex flex-wrap align-items-center justify-content-end">
                <span class="text-start w-100 label-2 font-1">Mérida, México</span>
                <span class="text-start w-100 label-3 font-2 d-flex justify-content-between mt-2">
                  <a class="direccion_color fuente-nova" href="https://maps.app.goo.gl/ucEpt5utRkaAQeBm9"
                    target="_blank" rel="noopener noreferrer">Dirección</a>
                  |
                  <span>+52 999 9306053</span>
                </span>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer py-3 border-0 px-lg-5 px-2"></div>
      </div>
    </div>
  </div>

  <!-- Toast de éxito -->
  <div aria-live="polite" aria-atomic="true" class="position-fixed top-50 start-50 translate-middle"
    style="z-index: 1055">
    <div ref="successToast" class="toast toast-3d text-dark px-5 py-4" role="alert" aria-live="assertive"
      aria-atomic="true">
      <div class="toast-content d-flex flex-column align-items-center text-center">
        <div class="check-circle mb-3">
          <svg viewBox="0 0 24 24" class="check-icon">
            <path fill="white" d="M9 16.2l-3.5-3.5 1.41-1.42L9 13.38l7.09-7.09L17.5 7.8z" />
          </svg>
        </div>
        <div class="toast-body fw-bold fuente-nova2 fs-5">Mensaje enviado con éxito</div>
      </div>
    </div>
  </div>

  <!-- Toast de error -->
  <div aria-live="polite" aria-atomic="true" class="position-fixed top-50 start-50 translate-middle"
    style="z-index: 1055">
    <div ref="errorToast" class="toast toast-3d text-danger px-5 py-4" role="alert" aria-live="assertive"
      aria-atomic="true">
      <div class="toast-content d-flex flex-column align-items-center text-center">
        <div class="check-circle bg-danger mb-3">
          <svg viewBox="0 0 24 24" class="check-icon2">
  <path fill="white" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"/>
</svg>
        </div>
        <div class="toast-body fw-bold fuente-nova2 fs-5">{{ errorMessage }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { Modal, Toast } from 'bootstrap'

export default {
  name: 'ContactModal',
  data() {
    return {
      form: {
        iName: '',
        iPhone: '',
        iCompany: '',
        iEmail: '',
        iMessage: '',
      },
      errorMessage: '',
      modalInstance: null,
      consultas: null
    }
  },
  mounted() {
    this.modalInstance = new Modal(this.$refs.contactModal)
    this.consultas = {
      url: 'https://proactive.lat/procesar.php',
      method: 'POST',
      headers: {}
    }
  },
  beforeUnmount() {
    this.modalInstance.hide()
  },
  methods: {
    showModal() {
      this.modalInstance.show()
    },
    showErrorToast(message) {
      this.errorMessage = message
      const toast = new Toast(this.$refs.errorToast)
      toast.show()
      setTimeout(() => {
        toast.hide()
      }, 2000)
    },
    validateForm() {
      const nameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ\s]{1,200}$/
      const emailRegex = /^(?=.{1,100}$)([^\s@]+@[^\s@]+\.[^\s@]+)$/
      const phoneRegex = /^[0-9]{10}$/
      const messageRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ0-9\s,\.\-]{3,500}$/

      if (!nameRegex.test(this.form.iName)) {
        this.showErrorToast('Nombre obligatorio')
        return
      }
      if (!phoneRegex.test(this.form.iPhone)) {
        this.showErrorToast('El Teléfono debe tener 10 dígitos')
        return
      }
      if (!nameRegex.test(this.form.iCompany)) {
        this.showErrorToast('Empresa obligatoria')
        return
      }
      if (!emailRegex.test(this.form.iEmail)) {
        this.showErrorToast('Email obligatorio')
        return
      }
      if (!messageRegex.test(this.form.iMessage)) {
        this.showErrorToast('El campo de mensaje no puede estar vacío.')
        return
      }

      this.errorMessage = ''
      const formData = new FormData()
      for (const key in this.form) {
        formData.append(key, this.form[key])
      }

      this.consultas.data = formData

      axios.request(this.consultas)
        .then(() => {
          const toast = new Toast(this.$refs.successToast)
          toast.show()
          Modal.getInstance(this.$refs.contactModal)?.hide()
          setTimeout(() => {
            toast.hide()
          }, 4000)

          this.form = { iName: '', iPhone: '', iCompany: '', iEmail: '', iMessage: '' }
        })
        .catch(err => {
          console.error('Error al enviar formulario:', err)
        })
    }
  }
}
</script>


<style scoped>
#contactModal {
  height: 100vh !important;
  width: 100vw !important;
}

.toast-3d {
  background-color: #FFFFFF;
  border-radius: 20px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border: 1px solid #e0e0e0;
  max-width: 340px;
  animation: fadeSlideUp 0.5s ease;
}

.toast-content {
  padding: 10px;
}

@keyframes fadeSlideUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.98);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.check-circle {
  background-color: #000000;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* border: 1px black solid; */
}

.check-icon {
  fill: white;
  width: 28px;
  height: 28px;
}

.check-icon2 {
  fill: white;
  width: 50px;
  height: 50px;
}

/* .toast-custom {
  background-color: #F0EFEB;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  padding: 1rem 1.5rem;
  max-width: 320px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  transition: transform 0.3s ease, opacity 0.3s ease;
  animation: slideIn 0.5s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.toast-body {
  font-size: 1.2rem;
  color: #333333;
  text-align: center;
} */

.form-label {
  font-weight: 600;
}

.modal-content {
  border-radius: 30px !important;
}

.btn-close-custom {
  border: none;
  background: transparent;
  color: #999;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;
}

.btn-close-custom:hover {
  color: #333;
}

.btn-contact {
  background-color: var(--color-2);
  color: white;
  border: none;
  border-radius: 30px;
  padding: 12px 40px;
  font-size: 16px;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.btn-contact:hover {
  opacity: 0.85;
}

input:focus,
textarea:focus {
  border-color: var(--primary) !important;
}

.direccion_color {
  text-decoration: none;
  color: black;
}

@media (min-width: 0px) and (max-width: 768px) {
  .modal-content {
    border-radius: 15px !important;
  }
}

.label-1 {
  font-size: 40px;
  font-weight: 600;
  color: var(--color-2);
}

.label-2 {
  font-size: 24px;
  font-weight: 600;
  color: var(--color-2);
}

.label-3 {
  font-size: 20px;
  color: var(--color-1);
}

.label-4 {
  color: red;
  font-size: 20px;
}

@media screen and (max-width:490px) {
  .btn_movil {
    padding: 6px 32px !important;
    font-size: 18px;
  }
}
</style>
